/* tslint:disable */
/* eslint-disable */
/**
 * Bioplan API
 * Backend API for Bioplan, an aquaculture production planning tool.
 *
 * Contact: support@optimeeringaqua.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type {Configuration} from '../configuration';
import type {AxiosPromise, AxiosInstance, RawAxiosRequestConfig} from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from '../common';
// @ts-ignore
import {BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap} from '../base';
// @ts-ignore
import type {EditTransfer} from '../bioplanModels';
// @ts-ignore
import type {Transfer} from '../bioplanModels';
// @ts-ignore
import type {WriteTransfer} from '../bioplanModels';
/**
 * PlanningTransferApi - axios parameter creator
 * @export
 */
export const PlanningTransferApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Get all transfer actions for a cage
     * @param {string} [planId]
     * @param {string} [siteId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    transfersGet: async (
      planId?: string,
      siteId?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/transfers/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (planId !== undefined) {
        localVarQueryParameter['planId'] = planId;
      }

      if (siteId !== undefined) {
        localVarQueryParameter['siteId'] = siteId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Create transfer for a cage
     * @param {WriteTransfer} writeTransfer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    transfersPost: async (writeTransfer: WriteTransfer, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'writeTransfer' is not null or undefined
      assertParamExists('transfersPost', 'writeTransfer', writeTransfer);
      const localVarPath = `/transfers/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'POST', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(writeTransfer, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Delete transfer by its identifier
     * @param {string} transferId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    transfersTransferIdDelete: async (
      transferId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'transferId' is not null or undefined
      assertParamExists('transfersTransferIdDelete', 'transferId', transferId);
      const localVarPath = `/transfers/{transferId}`.replace(
        `{${'transferId'}}`,
        encodeURIComponent(String(transferId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'DELETE', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get transfer by its identifier
     * @param {string} transferId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    transfersTransferIdGet: async (transferId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'transferId' is not null or undefined
      assertParamExists('transfersTransferIdGet', 'transferId', transferId);
      const localVarPath = `/transfers/{transferId}`.replace(
        `{${'transferId'}}`,
        encodeURIComponent(String(transferId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Update transfer for a cage
     * @param {string} transferId
     * @param {EditTransfer} editTransfer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    transfersTransferIdPut: async (
      transferId: string,
      editTransfer: EditTransfer,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'transferId' is not null or undefined
      assertParamExists('transfersTransferIdPut', 'transferId', transferId);
      // verify required parameter 'editTransfer' is not null or undefined
      assertParamExists('transfersTransferIdPut', 'editTransfer', editTransfer);
      const localVarPath = `/transfers/{transferId}`.replace(
        `{${'transferId'}}`,
        encodeURIComponent(String(transferId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'PUT', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(editTransfer, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * PlanningTransferApi - functional programming interface
 * @export
 */
export const PlanningTransferApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = PlanningTransferApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Get all transfer actions for a cage
     * @param {string} [planId]
     * @param {string} [siteId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async transfersGet(
      planId?: string,
      siteId?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Transfer>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.transfersGet(planId, siteId, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningTransferApi.transfersGet']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Create transfer for a cage
     * @param {WriteTransfer} writeTransfer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async transfersPost(
      writeTransfer: WriteTransfer,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Transfer>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.transfersPost(writeTransfer, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningTransferApi.transfersPost']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Delete transfer by its identifier
     * @param {string} transferId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async transfersTransferIdDelete(
      transferId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.transfersTransferIdDelete(transferId, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningTransferApi.transfersTransferIdDelete']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get transfer by its identifier
     * @param {string} transferId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async transfersTransferIdGet(
      transferId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Transfer>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.transfersTransferIdGet(transferId, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningTransferApi.transfersTransferIdGet']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Update transfer for a cage
     * @param {string} transferId
     * @param {EditTransfer} editTransfer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async transfersTransferIdPut(
      transferId: string,
      editTransfer: EditTransfer,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Transfer>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.transfersTransferIdPut(
        transferId,
        editTransfer,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningTransferApi.transfersTransferIdPut']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * PlanningTransferApi - factory interface
 * @export
 */
export const PlanningTransferApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = PlanningTransferApiFp(configuration);
  return {
    /**
     *
     * @summary Get all transfer actions for a cage
     * @param {PlanningTransferApiTransfersGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    transfersGet(
      requestParameters: PlanningTransferApiTransfersGetRequest = {},
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<Transfer>> {
      return localVarFp
        .transfersGet(requestParameters.planId, requestParameters.siteId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Create transfer for a cage
     * @param {PlanningTransferApiTransfersPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    transfersPost(
      requestParameters: PlanningTransferApiTransfersPostRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Transfer> {
      return localVarFp
        .transfersPost(requestParameters.writeTransfer, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Delete transfer by its identifier
     * @param {PlanningTransferApiTransfersTransferIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    transfersTransferIdDelete(
      requestParameters: PlanningTransferApiTransfersTransferIdDeleteRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .transfersTransferIdDelete(requestParameters.transferId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get transfer by its identifier
     * @param {PlanningTransferApiTransfersTransferIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    transfersTransferIdGet(
      requestParameters: PlanningTransferApiTransfersTransferIdGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Transfer> {
      return localVarFp
        .transfersTransferIdGet(requestParameters.transferId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Update transfer for a cage
     * @param {PlanningTransferApiTransfersTransferIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    transfersTransferIdPut(
      requestParameters: PlanningTransferApiTransfersTransferIdPutRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Transfer> {
      return localVarFp
        .transfersTransferIdPut(requestParameters.transferId, requestParameters.editTransfer, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * Request parameters for transfersGet operation in PlanningTransferApi.
 * @export
 * @interface PlanningTransferApiTransfersGetRequest
 */
export interface PlanningTransferApiTransfersGetRequest {
  /**
   *
   * @type {string}
   * @memberof PlanningTransferApiTransfersGet
   */
  readonly planId?: string;

  /**
   *
   * @type {string}
   * @memberof PlanningTransferApiTransfersGet
   */
  readonly siteId?: string;
}

/**
 * Request parameters for transfersPost operation in PlanningTransferApi.
 * @export
 * @interface PlanningTransferApiTransfersPostRequest
 */
export interface PlanningTransferApiTransfersPostRequest {
  /**
   *
   * @type {WriteTransfer}
   * @memberof PlanningTransferApiTransfersPost
   */
  readonly writeTransfer: WriteTransfer;
}

/**
 * Request parameters for transfersTransferIdDelete operation in PlanningTransferApi.
 * @export
 * @interface PlanningTransferApiTransfersTransferIdDeleteRequest
 */
export interface PlanningTransferApiTransfersTransferIdDeleteRequest {
  /**
   *
   * @type {string}
   * @memberof PlanningTransferApiTransfersTransferIdDelete
   */
  readonly transferId: string;
}

/**
 * Request parameters for transfersTransferIdGet operation in PlanningTransferApi.
 * @export
 * @interface PlanningTransferApiTransfersTransferIdGetRequest
 */
export interface PlanningTransferApiTransfersTransferIdGetRequest {
  /**
   *
   * @type {string}
   * @memberof PlanningTransferApiTransfersTransferIdGet
   */
  readonly transferId: string;
}

/**
 * Request parameters for transfersTransferIdPut operation in PlanningTransferApi.
 * @export
 * @interface PlanningTransferApiTransfersTransferIdPutRequest
 */
export interface PlanningTransferApiTransfersTransferIdPutRequest {
  /**
   *
   * @type {string}
   * @memberof PlanningTransferApiTransfersTransferIdPut
   */
  readonly transferId: string;

  /**
   *
   * @type {EditTransfer}
   * @memberof PlanningTransferApiTransfersTransferIdPut
   */
  readonly editTransfer: EditTransfer;
}

/**
 * PlanningTransferApi - object-oriented interface
 * @export
 * @class PlanningTransferApi
 * @extends {BaseAPI}
 */
export class PlanningTransferApi extends BaseAPI {
  /**
   *
   * @summary Get all transfer actions for a cage
   * @param {PlanningTransferApiTransfersGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningTransferApi
   */
  public transfersGet(requestParameters: PlanningTransferApiTransfersGetRequest = {}, options?: RawAxiosRequestConfig) {
    return PlanningTransferApiFp(this.configuration)
      .transfersGet(requestParameters.planId, requestParameters.siteId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Create transfer for a cage
   * @param {PlanningTransferApiTransfersPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningTransferApi
   */
  public transfersPost(requestParameters: PlanningTransferApiTransfersPostRequest, options?: RawAxiosRequestConfig) {
    return PlanningTransferApiFp(this.configuration)
      .transfersPost(requestParameters.writeTransfer, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Delete transfer by its identifier
   * @param {PlanningTransferApiTransfersTransferIdDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningTransferApi
   */
  public transfersTransferIdDelete(
    requestParameters: PlanningTransferApiTransfersTransferIdDeleteRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PlanningTransferApiFp(this.configuration)
      .transfersTransferIdDelete(requestParameters.transferId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get transfer by its identifier
   * @param {PlanningTransferApiTransfersTransferIdGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningTransferApi
   */
  public transfersTransferIdGet(
    requestParameters: PlanningTransferApiTransfersTransferIdGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PlanningTransferApiFp(this.configuration)
      .transfersTransferIdGet(requestParameters.transferId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Update transfer for a cage
   * @param {PlanningTransferApiTransfersTransferIdPutRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningTransferApi
   */
  public transfersTransferIdPut(
    requestParameters: PlanningTransferApiTransfersTransferIdPutRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PlanningTransferApiFp(this.configuration)
      .transfersTransferIdPut(requestParameters.transferId, requestParameters.editTransfer, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
